import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { GET_REFERRALS } from "../services/Apis";
import { encStorage } from "../hooks/encStorage";
import axios from "axios";

function Sidebar({ props }) {

  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);
  const [referrals, setReferrals] = useState([]);

  const fetchReferrals = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(GET_REFERRALS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      setReferrals(data.records.length);
      encStorage.setItem("refer", data.records.length);
      //console.log(referrals);
      //console.log(encStorage.getItem("refer"));
      //console.log(totCommissions);
    } catch (error) {
      console.error("Error fetching referrals:", error);
    }
  };

  useEffect(() => {
    fetchReferrals(); // Run on page load
    const interval = setInterval(fetchReferrals, 60000); // Run every 60 seconds
    return () => clearInterval(interval);
  }, []);


  return (
    <div id="layoutSidenav_nav">
      <nav
        className="sb-sidenav accordion sb-sidenav-light"
        id="sidenavAccordion"
      >
        <div className="sb-sidenav-menu">
          <div className="nav">
            <Link
              className={`nav-link ${isActive("home") ? "active" : ""}`}
              to="/market-watch"
            >
              <div className="sb-nav-link-icon">
                <i className="fas fa-home"></i>
              </div>
              Dashboard
            </Link>
          </div>
        </div>
        <div className="sb-sidenav-footer bg-primary px-3 text-light">
          &copy; Market Trade {new Date().getFullYear()}
        </div>
      </nav>
    </div>
  );
}

export default Sidebar;
